import {
  ADD_BOOK,
  FEATURED_BOOKS,
  LOADED_BOOKS,
  REMOVE_BOOK,
  SEARCH_BOOKS,
  SET_BOOK,
  UPDATE_BOOK,
} from "./actionTypes";

export const loadBooks = (books) => ({
  type: LOADED_BOOKS,
  payload: books,
});

export const addBook = (book) => ({
  type: ADD_BOOK,
  payload: book,
});

export const removeBook = (id) => ({
  type: REMOVE_BOOK,
  payload: id,
});

export const updateBook = (book) => ({
  type: UPDATE_BOOK,
  payload: book,
});

export const setBook = (book) => ({
  type: SET_BOOK,
  payload: book,
});

export const featuredBooks = () => ({
    type: FEATURED_BOOKS,
});

export const searchBooks = (search) => ({
    type: SEARCH_BOOKS,
    payload: search,
});
